import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const UseSearchParam = (params, key = 'page') => {
  const location = useLocation();
  return useMemo(() => params?.get(key), [location.search]);
};

export default UseSearchParam;
